package com.neurobs.ccabserver.administrator.view

import com.neurobs.ccab.DataSyncStateSource
import com.neurobs.js.dom.{ElementFactory, Grid, HideableRowGrid}
import com.neurobs.js.dom.Grid._
import com.neurobs.js.view
import com.neurobs.js.view.Gui
import com.neurobs.util.Logger
import org.scalajs.dom.raw.HTMLElement
import scalatags.JsDom.all._

class ControllerSessionView (dataSyncSource: Option[DataSyncStateSource], logger: Logger, showComments: Boolean, gui: Gui, showSystemShutdown: Boolean) {
	import com.neurobs.js.dom.ElementFactory._
	import com.neurobs.js.dom.DOMViewElement._
	import ControllerSessionView._
	implicit def toE(c: view.Container): HTMLElement = toElement(c)

	val testSession = new TestSessionView(logger, showComments)
	def setTestSessionVisible(visible: Boolean): Unit = grid.setRowVisible(testSession.container, visible)

	val videoChat = new VideoChatView(gui)
	def setVideoChatVisible(visible: Boolean): Unit = grid.setRowVisible(videoChat.container, visible)

	val dataSyncView: Option[TestStationDataSyncView] = dataSyncSource.map(new TestStationDataSyncView(_))

	private val connectionStatusDiv = div.render
	def setConnectionStatus(s: Option[String], displayType: StatusDisplayType.Value = StatusDisplayType.Error): Unit = {
		grid.setRowVisible(connectionStatusDiv, s.isDefined)
		connectionStatusDiv.innerHTML = s.getOrElse("")
		connectionStatusDiv.className = displayType match {
			case StatusDisplayType.Info => connectionStatusInfoClass
			case StatusDisplayType.Error => connectionStatusErrorClass
			case StatusDisplayType.Attention => connectionStatusAttentionClass
		}
	}

	private val domCloseLink = makeLink(text = "Close")
	val closeLink: view.Link = domCloseLink

	private val domConnectionLink = makeLink(text = "Connection")
	val connectionLink: view.Link = domConnectionLink

	//private val domShutdownAppLink = makeLink(text = "Shutdown Test Station Application")
	//val shutdownAppLink: view.Link = domShutdownAppLink

	private val domShutdownSystemLink = makeLink(text = "Shutdown Test Station Computer")
	val shutdownSystemLink: view.Link = domShutdownSystemLink

	private val errorLog = textarea(rows := 4, cols := 50).render
	def addError(error: String) : Unit = {
		grid.setRowVisible(errorLog, visible = true)
		errorLog.value = error + "\n" + errorLog.value
	}

	//val sessionSelection = new SequenceSelectionView
	val sessionSelectionNew = div().render
	def setSessionSelectionVisible(visible: Boolean): Unit = {
		//grid.setRowVisible(sessionSelection.container, visible)
		grid.setRowVisible(sessionSelectionNew, visible)
		//grid.setRowVisible(domShutdownAppLink, visible)
		if (showSystemShutdown) {
			grid.setRowVisible(domShutdownSystemLink, visible)
		}
	}

	def setTitle(title: String): Unit = panel.titleText.setValue(title)

	private val panel = new PanelView(title = "", showRefresh = false, fullWidth = false, Some(Array(("background-color", "#445"), ("color", "#FFFFFF"), ("min-width", "40em"), ("border", "solid 0.3em #445"))))
	panel.setRightCorner(domCloseLink)
	panel.setLeftCorner(domConnectionLink)

	def setAlertType(a: AlertIndicatorType.Value): Unit =
	{
		val animation = a match {
			case AlertIndicatorType.Alert => "controller-session-alert-animation 2s step-start 0s infinite"
			case AlertIndicatorType.Warning => "controller-session-warning-animation 2s step-start 0s infinite"
			case AlertIndicatorType.None => ""
		}
		ElementFactory.toElement(panel.container).style.animation = animation
	}

	def setRecurringEvent(intervalMs: Int)(processor: () => Boolean): Unit = {
		toElement(container).id = com.neurobs.js.dom.Timer.createRecurringElementTimer(intervalMs)(processor)
	}

	private val grid = new HideableRowGrid(fullWidth = false, emGapSize = panel.grid.emGapSize)
	panel.grid.addRow(grid.container)
	grid.addRow(videoChat.container)
	setVideoChatVisible(false)
	grid.addRow(connectionStatusDiv)
	grid.setRowVisible(connectionStatusDiv, visible = false)
	//grid.addRow((sessionSelection.container, Grid.alignCenter))
	grid.addRow((sessionSelectionNew, Grid.alignCenter))
	setSessionSelectionVisible(false)
	grid.addRow(testSession.container)
	setTestSessionVisible(false)
	dataSyncView.foreach(v => grid.addRow(v.container))
	//grid.addRow(domShutdownAppLink)
	if (showSystemShutdown) {
		grid.addRow(domShutdownSystemLink)
	}
	grid.addRow(errorLog)
	grid.setRowVisible(errorLog, visible = false)
	panel.container.appendChild(input(`type` := "text", display := "none", name := viewElementName).render)

	val container: view.Container = panel.container
}

object ControllerSessionView {
	private val connectionStatusInfoClass = "controller-session-connection-status-info"
	private val connectionStatusErrorClass = "controller-session-connection-status-error"
	private val connectionStatusAttentionClass = "controller-session-connection-status-attention"

	object StatusDisplayType extends Enumeration {
		val Info, Error, Attention = Value
	}

	object AlertIndicatorType extends Enumeration {
		val Alert, Warning, None = Value
	}

	/** The views will contain an element with this name. This is for
	 * detecting if any ControllerSessionView's are on the page using
	 * getElementsByName. */
	val viewElementName = "controller_view"
}